import { useAuth } from '@domain/auth/auth.hook';
import React, { useState } from 'react';
import { CancelToken } from 'axios';
import { usePagedData } from '@domain/hooks/use.paged.data';
import { FormControl, FormHelperText, InputLabel } from '@material-ui/core';
import { MetricSelectionProps } from '@screens/players/player.actions/metrics/metric.selection.props';
import { MetricsComboBoxStyled, MetricsSelect } from '@screens/players/player.actions/metrics/metrics.styles';

interface GamesData {
  id: string;
  nickname: string;
  name: string;
  group: string;
  category: string;
}

const GamesComboBox = ({ onChange, comboLabel }: MetricSelectionProps) => {
  const { authorizedServices } = useAuth();
  function selectStats(e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown; type?: string; checked?: boolean }>) {
    e.preventDefault();
    onChange(e.target.value as string);
  }

  const comboboxLabel = comboLabel;

  async function getGamesId(data: any, page: number, cancelToken: CancelToken | undefined) {
    return authorizedServices.get<GamesData[]>('/admin/domains/games', { cancelToken });
  }
  const { responseData, loading, validationErrors } = usePagedData(null, getGamesId, {});

  const gamesIdData = responseData ?? [];

  const [gameId, setGameId] = useState('');

  function handleGameIdChange(e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown; type?: string; checked?: boolean }>) {
    setGameId(e.target.value as string);
    selectStats(e);
  }

  return (
    <>
      <MetricsComboBoxStyled>
        <FormControl>
          <InputLabel id='gamesId'>{comboboxLabel}</InputLabel>
          <MetricsSelect
            native
            labelId='gamesId'
            id='gamesId'
            inputProps={{ name: 'gamesId' }}
            disabled={loading}
            onChange={handleGameIdChange}
            value={gameId}
          >
            <option>N/A</option>
            {gamesIdData.map((v) => (
              <option key={v.id} value={v.id}>
                {v.id}
              </option>
            ))}
          </MetricsSelect>
          <FormHelperText error>{validationErrors}</FormHelperText>
        </FormControl>
      </MetricsComboBoxStyled>
    </>
  );
};

export default GamesComboBox;
